import * as React from 'react';
import { observer } from 'mobx-react';
import { get, has, isEqual } from 'lodash';
import * as classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import { PortalSearchBarField } from '../layout';

// Styles
const s = require('./Picker.css');
const tickMarkIcon = require('./../../assets/tick-blue.svg');
const expandIcon = require('./../../assets/expand-icon.svg');

// Props
interface IPickerProps {
    onContainerClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    containerClassName?: string | null;
    className?: string | null;
    show: boolean;
    valueSelected?: any;
    options?: IPickerOptionGroup[];
    onValueSelectedChange: (newValue: any) => (e: React.MouseEvent<HTMLButtonElement>) => void;
    field?: {
        above?: boolean;
        label: string;
        value: any;
        isImportant?: boolean;
        isCorrect?: boolean;
        onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
        onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    };
}

// Interfaces
interface IPickerOptionGroup {
    name: string;
    options: IPickerOption[];
}

export interface IPickerOption {
    key: string;
    value: any;
    title: string;
    subline?: string;
    dim?: boolean;
}

// Component
@observer
export class Picker extends React.Component<IPickerProps, {}> {
    static get defaultProps(): IPickerProps {
        return {
            onContainerClick: null,
            containerClassName: null,
            className: null,
            show: false,
            valueSelected: null,
            options: [],
            onValueSelectedChange: null,
            field: null
        };
    }

    render() {
        return (
            <div
                onClick={this.handlePickerClick}
                className={classNames(s.container, this.props.containerClassName, {
                    [s.open]: this.props.show
                })}
            >
                {this.renderField(true)}

                <AnimateHeight height={this.props.show ? 'auto' : 0} duration={300}>
                    <div className={classNames(s.picker, this.props.className)}>
                        {this.props.options.map((group) => (
                            <div key={group.name.replace(/ /gi, '-').toLowerCase()} className={s.group}>
                                <p>{group.name}</p>
                                {group.options.map((option) => (
                                    <button
                                        key={option.key}
                                        className={classNames('picker-list-entry', {
                                            [s.active]: isEqual(this.props.valueSelected, option.value),
                                            [s.dim]: typeof option.dim !== 'undefined' && option.dim
                                        })}
                                        onClick={
                                            this.props.onValueSelectedChange
                                                ? this.props.onValueSelectedChange(option.value)
                                                : undefined
                                        }
                                    >
                                        <div>
                                            <strong>{option.title}</strong>
                                            {typeof option.subline !== 'undefined' && option.subline && (
                                                <span>{option.subline}</span>
                                            )}
                                        </div>
                                        <img src={tickMarkIcon} alt="" />
                                    </button>
                                ))}
                            </div>
                        ))}
                    </div>
                </AnimateHeight>

                {this.renderField(false)}
            </div>
        );
    }

    private renderField(above: boolean) {
        if (this.props.field && has(this.props.field, 'value') && has(this.props.field, 'label')) {
            const abovePreference = get(this.props.field, 'above', false);

            return above === abovePreference ? (
                <PortalSearchBarField
                    field="shippingAddress"
                    value={this.props.field.value}
                    icon={expandIcon}
                    lightness={this.props.show ? 4 : 0}
                    label={this.props.field.label}
                    isImportant={this.props.field.isImportant}
                    isCorrect={this.props.field.isCorrect}
                    onFocus={this.handleFieldFocus}
                    onBlur={this.handleFieldBlur}
                    className={classNames({
                        [s.above]: above
                    })}
                />
            ) : null;
        }
    }

    private handlePickerClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (this.props.onContainerClick) {
            this.props.onContainerClick(e);
        }
    };

    private handleFieldFocus = (field: string, e: React.FocusEvent<HTMLInputElement>) => {
        if (this.props.field && typeof this.props.field.onFocus !== 'undefined' && this.props.field.onFocus) {
            this.props.field.onFocus(e);
        }
    };

    private handleFieldBlur = (field: string, e: React.FocusEvent<HTMLInputElement>) => {
        const el = e.relatedTarget ? (e.relatedTarget as HTMLButtonElement) : null;
        if (el && el.classList.contains('picker-list-entry')) {
            return;
        }

        if (this.props.field && typeof this.props.field.onBlur !== 'undefined' && this.props.field.onBlur) {
            this.props.field.onBlur(e);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/forms/Picker.tsx